import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import schoolLogo from '../school-brand.jpg'; 
import * as Styles from './styles';

function LandingMobile() {
  const [quickEmail, setQuickEmail] = useState('');
  const [quickPassword, setQuickPassword] = useState('');
  const [showQuickLogin, setShowQuickLogin] = useState(false);
  
  // Forgot Password States
  const [isForgotMode, setIsForgotMode] = useState(false);
  const [forgotEmail, setForgotEmail] = useState('');
  const [forgotMessage, setForgotMessage] = useState('');

  const handleQuickLogin = async (e) => {
    e.preventDefault();
    try {
      localStorage.removeItem('instructorId');
      localStorage.removeItem('learnerId');
      localStorage.removeItem('userId');
      localStorage.removeItem('adminToken');

      const response = await fetch('/api/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: quickEmail, password: quickPassword })
      });
      const data = await response.json();
      if (response.ok) {
        localStorage.setItem('needsPasswordReset', data.needsPasswordReset ? 'true' : 'false');

        if (data.role === 'admin') {
          localStorage.setItem('userRole', 'admin');
          localStorage.setItem('adminToken', data.token || 'mock-admin-token-secure');
          window.location.assign('/admin');
        } else if (data.role === 'instructor') {
          localStorage.setItem('userRole', 'instructor');
          localStorage.setItem('instructorId', data.id || data.instructorId);
          localStorage.setItem('token', data.token || '');
          window.location.assign('/instructor-dash');
        } else {
          localStorage.setItem('userRole', 'learner');
          localStorage.setItem('userId', data.id || data.userId);
          localStorage.setItem('learnerId', data.id || data.userId);
          localStorage.setItem('userName', data.name || "Learner Driver");
          localStorage.setItem('token', data.token || '');
          window.location.assign(`/learner-dash/${data.instructor_id || 5}`);
        }
      } else {
        alert(data.error || "Login failed.");
      }
    } catch (err) {
      alert("Server error.");
    }
  };

  const handleForgotPasswordSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch('/api/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: forgotEmail })
      });
      const data = await res.json();
      if (res.ok) {
        setForgotMessage('Password reset link sent! Check your email.');
      } else {
        setForgotMessage(data.error || 'Could not send reset link.');
      }
    } catch (err) {
      setForgotMessage('Server error. Please try again.');
    }
  };

  return (
    <div style={{ ...Styles.containerStyle, padding: '0 0 50px 0', overflowX: 'hidden', background: '#0f172a', color: '#ffffff', minHeight: '100vh' }}>
      
      {/* --- MINIMALIST APP HEADER --- */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '14px 18px', background: '#090d16', borderBottom: '1px solid rgba(255,255,255,0.06)', position: 'sticky', top: 0, zIndex: 1000 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <img src={schoolLogo} alt="Logo" style={{ width: '32px', height: '32px', borderRadius: '50%', objectFit: 'cover', border: '2px solid #3b82f6' }} />
          <span style={{ color: '#fff', fontWeight: '800', fontSize: '1.1rem', letterSpacing: '-0.5px' }}>LessonLane</span>
        </div>

        {/* Far Right Login / Profile Icon */}
        <button 
          onClick={() => { setShowQuickLogin(!showQuickLogin); setIsForgotMode(false); setForgotMessage(''); }}
          title="Portal Login"
          style={{ background: 'transparent', border: 'none', color: '#fff', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '4px' }}
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2C9.24 2 7 4.24 7 7C7 9.42 8.74 11.43 11 11.9V13.1C7.58 13.54 5 16.48 5 20H19C19 16.48 16.42 13.54 13 13.1V11.9C15.26 11.43 17 9.42 17 7C17 4.24 14.76 2 12 2Z" fill="#FFFFFF"/>
          </svg>
        </button>
      </div>

      {/* --- QUICK LOGIN / FORGOT PASSWORD EXPANDABLE BOX --- */}
      {showQuickLogin && (
        <div style={{ padding: '16px 16px 0 16px', maxWidth: '450px', margin: '0 auto', width: '100%', boxSizing: 'border-box' }}>
          {!isForgotMode ? (
            <form onSubmit={handleQuickLogin} style={{ background: '#1e293b', padding: '20px', borderRadius: '16px', border: '2px solid #3b82f6', boxShadow: '0 12px 30px rgba(0, 0, 0, 0.4)' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                <h4 style={{ margin: 0, fontSize: '1rem', color: '#ffffff', fontWeight: '800' }}>Portal Sign In</h4>
                <button type="button" onClick={() => setShowQuickLogin(false)} style={{ background: 'none', border: 'none', fontSize: '14px', cursor: 'pointer', color: '#94a3b8' }}>✕</button>
              </div>
              <input 
                type="email" 
                placeholder="Email address" 
                value={quickEmail} 
                onChange={e => setQuickEmail(e.target.value)} 
                required 
                style={{ width: '100%', padding: '11px 12px', marginBottom: '10px', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.15)', boxSizing: 'border-box', fontSize: '13px', background: '#0f172a', color: '#fff', outline: 'none' }}
              />
              <input 
                type="password" 
                placeholder="Password" 
                value={quickPassword} 
                onChange={e => setQuickPassword(e.target.value)} 
                required 
                style={{ width: '100%', padding: '11px 12px', marginBottom: '6px', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.15)', boxSizing: 'border-box', fontSize: '13px', background: '#0f172a', color: '#fff', outline: 'none' }}
              />
              <div style={{ textAlign: 'right', marginBottom: '12px' }}>
                <button 
                  type="button"
                  onClick={() => { setIsForgotMode(true); setForgotMessage(''); }}
                  style={{ background: 'none', border: 'none', fontSize: '11.5px', color: '#60a5fa', textDecoration: 'none', cursor: 'pointer', padding: 0 }}
                >
                  Forgot password?
                </button>
              </div>
              <button type="submit" style={{ width: '100%', padding: '11px', background: '#3b82f6', color: '#fff', border: 'none', borderRadius: '8px', fontWeight: 'bold', fontSize: '13px', cursor: 'pointer' }}>
                Sign In ➔
              </button>
            </form>
          ) : (
            <form onSubmit={handleForgotPasswordSubmit} style={{ background: '#1e293b', padding: '20px', borderRadius: '16px', border: '2px solid #3b82f6', boxShadow: '0 12px 30px rgba(0, 0, 0, 0.4)' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                <h4 style={{ margin: 0, fontSize: '1rem', color: '#ffffff', fontWeight: '800' }}>Reset Password</h4>
                <button type="button" onClick={() => setShowQuickLogin(false)} style={{ background: 'none', border: 'none', fontSize: '14px', cursor: 'pointer', color: '#94a3b8' }}>✕</button>
              </div>
              <p style={{ fontSize: '12px', color: '#94a3b8', marginBottom: '12px', lineHeight: '1.4' }}>
                Enter your account email and we'll send you a recovery link.
              </p>
              <input 
                type="email" 
                placeholder="Enter your email address" 
                value={forgotEmail} 
                onChange={e => setForgotEmail(e.target.value)} 
                required 
                style={{ width: '100%', padding: '11px 12px', marginBottom: '10px', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.15)', boxSizing: 'border-box', fontSize: '13px', background: '#0f172a', color: '#fff', outline: 'none' }}
              />
              {forgotMessage && (
                <div style={{ fontSize: '12px', color: forgotMessage.includes('sent') ? '#10b981' : '#f87171', marginBottom: '10px' }}>
                  {forgotMessage}
                </div>
              )}
              <button type="submit" style={{ width: '100%', padding: '11px', background: '#10b981', color: '#fff', border: 'none', borderRadius: '8px', fontWeight: 'bold', fontSize: '13px', cursor: 'pointer', marginBottom: '8px' }}>
                Send Reset Link ➔
              </button>
              <div style={{ textAlign: 'center' }}>
                <button 
                  type="button" 
                  onClick={() => setIsForgotMode(false)}
                  style={{ background: 'none', border: 'none', color: '#94a3b8', fontSize: '11.5px', cursor: 'pointer', textDecoration: 'underline' }}
                >
                  Back to Sign In
                </button>
              </div>
            </form>
          )}
        </div>
      )}

      {/* --- COMPACT HERO HEADER WITH WATERMARK --- */}
      <header style={{ textAlign: 'center', padding: '28px 16px 20px', backgroundColor: '#090d16', borderBottom: '1px solid rgba(255,255,255,0.06)', position: 'relative', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: '200px', height: '200px', backgroundImage: `url(${schoolLogo})`, backgroundSize: 'contain', backgroundRepeat: 'no-repeat', backgroundPosition: 'center', opacity: 0.10, pointerEvents: 'none', zIndex: 0 }} />

        <div style={{ position: 'relative', zIndex: 1 }}>
          <h1 style={{ fontSize: '1.6rem', fontWeight: '900', marginBottom: '6px', color: '#ffffff', letterSpacing: '-0.5px', lineHeight: '1.2' }}>
            Less Admin. <span style={{ color: '#60a5fa' }}>More Driving.</span>
          </h1>
          <p style={{ fontSize: '0.85rem', color: '#94a3b8', fontWeight: '400', margin: '0 auto', maxWidth: '300px', lineHeight: '1.4' }}>
            Manage students, bookings and lessons on the go.
          </p>
        </div>
      </header>

      {/* --- 2x2 APP TILE GRID --- */}
      <div style={{ padding: '24px 16px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px' }}>
          
          {/* Tile 1: Register */}
          <Link to="/apply" onClick={() => window.scrollTo({ top: 0, behavior: 'instant' })} style={{ textDecoration: 'none' }}>
            <div style={{ background: 'linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)', padding: '22px 14px', borderRadius: '18px', textAlign: 'center', boxShadow: '0 10px 25px rgba(37, 99, 235, 0.35)', height: '100%', boxSizing: 'border-box', border: '1px solid rgba(255,255,255,0.2)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-between' }}>
              <div style={{ width: '40px', height: '40px', background: 'rgba(255,255,255,0.2)', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '12px' }}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#ffffff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4"></circle><line x1="20" y1="8" x2="20" y2="14"></line><line x1="23" y1="11" x2="17" y2="11"></line></svg>
              </div>
              <div>
                <div style={{ fontWeight: '800', color: '#ffffff', fontSize: '1rem', letterSpacing: '-0.3px', lineHeight: '1.2' }}>Register</div>
                <div style={{ fontSize: '0.73rem', color: 'rgba(255,255,255,0.85)', marginTop: '4px' }}>Get started as instructor</div>
              </div>
            </div>
          </Link>

          {/* Tile 2: About LessonLane */}
          <Link to="/about" onClick={() => window.scrollTo({ top: 0, behavior: 'instant' })} style={{ textDecoration: 'none' }}>
            <div style={{ background: 'linear-gradient(135deg, #059669 0%, #047857 100%)', padding: '22px 14px', borderRadius: '18px', textAlign: 'center', boxShadow: '0 10px 25px rgba(5, 150, 105, 0.35)', height: '100%', boxSizing: 'border-box', border: '1px solid rgba(255,255,255,0.2)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-between' }}>
              <div style={{ width: '40px', height: '40px', background: 'rgba(255,255,255,0.2)', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '12px' }}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#ffffff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
              </div>
              <div>
                <div style={{ fontWeight: '800', color: '#ffffff', fontSize: '0.95rem', letterSpacing: '-0.3px', lineHeight: '1.2' }}>About Us</div>
                <div style={{ fontSize: '0.73rem', color: 'rgba(255,255,255,0.85)', marginTop: '4px' }}>Built for instructors</div>
              </div>
            </div>
          </Link>

          {/* Tile 3: Map / Find Us */}
          <Link to="/map" onClick={() => window.scrollTo({ top: 0, behavior: 'instant' })} style={{ textDecoration: 'none' }}>
            <div style={{ background: 'linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%)', padding: '22px 14px', borderRadius: '18px', textAlign: 'center', boxShadow: '0 10px 25px rgba(124, 58, 237, 0.35)', height: '100%', boxSizing: 'border-box', border: '1px solid rgba(255,255,255,0.2)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-between' }}>
              <div style={{ width: '40px', height: '40px', background: 'rgba(255,255,255,0.2)', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '12px' }}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#ffffff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"></polygon><line x1="8" y1="2" x2="8" y2="18"></line><line x1="16" y1="6" x2="16" y2="22"></line></svg>
              </div>
              <div>
                <div style={{ fontWeight: '800', color: '#ffffff', fontSize: '1rem', letterSpacing: '-0.3px', lineHeight: '1.2' }}>Find Us</div>
                <div style={{ fontSize: '0.73rem', color: 'rgba(255,255,255,0.85)', marginTop: '4px' }}>Interactive coverage map</div>
              </div>
            </div>
          </Link>

          {/* Tile 4: Contact Us */}
          <Link to="/contact" onClick={() => window.scrollTo({ top: 0, behavior: 'instant' })} style={{ textDecoration: 'none' }}>
            <div style={{ background: 'linear-gradient(135deg, #d97706 0%, #b45309 100%)', padding: '22px 14px', borderRadius: '18px', textAlign: 'center', boxShadow: '0 10px 25px rgba(217, 119, 6, 0.35)', height: '100%', boxSizing: 'border-box', border: '1px solid rgba(255,255,255,0.2)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-between' }}>
              <div style={{ width: '40px', height: '40px', background: 'rgba(255,255,255,0.2)', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '12px' }}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#ffffff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>
              </div>
              <div>
                <div style={{ fontWeight: '800', color: '#ffffff', fontSize: '1rem', letterSpacing: '-0.3px', lineHeight: '1.2' }}>Contact Us</div>
                <div style={{ fontSize: '0.73rem', color: 'rgba(255,255,255,0.85)', marginTop: '4px' }}>We're here to help</div>
              </div>
            </div>
          </Link>

        </div>
      </div>

      {/* --- MOBILE FOOTER --- */}
      <div style={{ textAlign: 'center', padding: '24px 16px', background: '#090d16', color: '#94a3b8', marginTop: '40px', borderTop: '1px solid rgba(255,255,255,0.06)' }}>
        <p style={{ fontSize: '11px', margin: 0 }}>
          &copy; 2026 LessonLane.co.uk. All rights reserved.
        </p>
      </div>

    </div>
  );
}

export default LandingMobile;